import React, { useEffect, useRef } from 'react';
import '../styles/lifeAtSynectiks.css';
import lifeAtSynectiksImg1 from '../../../../assets/company/careers/group1.png';
import lifeAtSynectiksImg2 from '../../../../assets/company/careers/group2.png';
import lifeAtSynectiksImg3 from '../../../../assets/company/careers/group3.png';
import lifeAtSynectiksImg4 from '../../../../assets/company/careers/group4.png';
import lifeAtSynectiksImg5 from '../../../../assets/company/careers/group14.png';
// import lifeAtSynectiksImg6 from '../../../../assets/company/careers/group12.jpg';
import lifeAtSynectiksImg7 from '../../../../assets/company/careers/group13.png';
// import lifeAtSynectiksImg8 from '../../../../assets/company/careers/group8.jpg';
// import lifeAtSynectiksImg9 from '../../../../assets/company/careers/group9.jpg';
// import lifeAtSynectiksImg10 from '../../../../assets/company/careers/group10.jpg';
import lifeAtSynectiksImg11 from '../../../../assets/company/careers/group11.jpg';





const LifeAtSynectiksSection = () => {
  const textRef = useRef(null);
  const imageRef = useRef(null);

  useEffect(() => {
    const elements = [textRef.current, imageRef.current];

    const options = { threshold: 0.1 };

    const callback = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate');
          observer.unobserve(entry.target);
        }
      });
    };

    const observer = new IntersectionObserver(callback, options);

    elements.forEach(el => {
      if (!el) return;
      const rect = el.getBoundingClientRect();
      const windowHeight = window.innerHeight || document.documentElement.clientHeight;

      if (rect.top <= windowHeight * 0.9) {
        setTimeout(() => el.classList.add('animate'), 50);
      } else {
        observer.observe(el);
      }
    });

    return () => observer.disconnect();
  }, []);

  return (
    <section className="life-at-synectiks-section">
      <div className="life-at-synectiks-container">
        <div className="life-at-synectiks-text" ref={textRef}>
          <h2>Life at Synectiks!</h2>
          <h3>Be Happy, Healthy and Inspired!!</h3>
          <p>
            To start with, we provide a competitive salary and employer-paid
            health benefits. We offer a flexible vacation plan, paid maternal
            and parental leave, tuition assistance, learning development
            opportunities, sports events, team lunches, pot-lucks, team outings
            and annual office celebrations - all for you to connect, refresh and
            thrive.
          </p>
        </div>
        <div className="life-at-synectiks-images" ref={imageRef}>
          <img src={lifeAtSynectiksImg1} alt="Team Celebration" />
          <img src={lifeAtSynectiksImg2} alt="Team Collaboration" />
          <img src={lifeAtSynectiksImg3} alt="Office Workspace" />
          <img
            src={lifeAtSynectiksImg5}
            alt="The Synectiks team posing together"
          />
          <img src={lifeAtSynectiksImg11} alt="Team Lunch" />
          <img src={lifeAtSynectiksImg4} alt="Office Activity" />
          <img src={lifeAtSynectiksImg7} alt="Office Activity1" />
        </div>
      </div>
    </section>
  );
};

export default LifeAtSynectiksSection;